'use client';

import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import currentDateTimeStamp from '@/libs/currentDateTimestamp/currentDateTimestamp';
import { useEnvContext } from '@/context/envContext';

// Retain this for testing purposes as it's a portrait ratio

/*
This component manages the next image function for grid image only.
It allows us to scoppe 'use client'  without causing issues in files/pages where we're running exports directly.
import Image from 'next/image';
*/
type Props = {
  GridType: 'assetDownload' | 'findmore' | 'toppicks' | 'clientlist' | 'webinar' | 'closelyrelated' | 'singlegrid' | 'singlegridlarge';
  resId: string;
  primarySiteName: string;
  thumbnail?: string;
  fallbackimage: string;
};
const GridImages = ({
  GridType,
  resId,
  thumbnail,
  fallbackimage
}: Props) => {
  const {
    cdnEnv: env
  } = useEnvContext();

  //Set up vars with defaults where applicable & where the value will not change often
  let gridImageName = 'default',
    src = 'https://www.techtarget.com/rms/fallback-cats/genericMulti/genericMulti-0.jpg',
    className,
    alt,
    priority = true,
    // set as false to enable loading-lazy
    width,
    height,
    styleWidth = '100%',
    styleHeight = '',
    sizes = '(max-width: 768px) 100vw, (max-width: 990px) 50vw, 50vw',
    // Removing placeholder as it errors on string not assignable??
    //placeHolder = 'empty', //default, set as blur or ...
    objectFit = '';
  switch (GridType) {
    case 'assetDownload':
      gridImageName = 'assetdownload-image';
      className = 'asset-download-image';
      src = `${env}/bitpipe/covers/${resId}_ch.png?${currentDateTimeStamp()}`;
      alt = 'selected-download-image';
      width = 315;
      height = 237;
      break;
    case 'findmore':
      gridImageName = 'findmore-image';
      src = `${env}/bitpipe/covers/${resId}_ch.png`;
      alt = 'findmore card image';
      width = 315;
      height = 237;
      break;
    case 'toppicks':
      gridImageName = 'toppicks-image';
      src = `${env}/bitpipe/covers/${resId}_ch.png`;
      alt = 'topPicks card image';
      width = 315;
      height = 237;
      break;
    case 'clientlist':
      gridImageName = 'clientlist-image';
      src = `${env}/bitpipe/covers/${resId}_ch.png`;
      alt = 'clientlist card image';
      priority = false;
      width = 315;
      height = 237;
      objectFit = 'contain';
      break;
    case 'webinar':
      gridImageName = 'clientlist-image';
      src = thumbnail ? thumbnail : src;
      alt = 'clientlist card image';
      priority = false;
      width = 315;
      height = 237;
      objectFit = 'contain';
      break;
    case 'closelyrelated':
      gridImageName = 'closelyrelated-image';
      src = `${env}/bitpipe/covers/${resId}_ch.png`;
      alt = 'closelyRelated card image';
      width = 315;
      height = 237;
      //placeHolder = 'data:image/...';
      break;
    case 'singlegrid':
      gridImageName = 'singlegrid-image';
      src = `${env}/bitpipe/covers/${resId}_ch.png?t=${currentDateTimeStamp()}`;
      alt = 'singlegrid card image';
      width = 315;
      height = 237;
      break;
    case 'singlegridlarge':
      gridImageName = 'singlegrid-image-large';
      src = `${env}/bitpipe/covers/${resId}_ch.png?t=${currentDateTimeStamp()}`;
      alt = 'singlegrid card image large';
      width = 315;
      height = 237;
      break;
    default:
      gridImageName = 'default';
      src = `https://www.techtarget.com/rms/fallback-cats/genericMulti/genericMulti-0.jpg`;
      alt = 'singlegrid card image large';
      width = 315;
      height = 237;
  }
  const [imgSrc, setImgSrc] = useState(src);
  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  // Fallback images

  return <Image className={className} data-bdd={gridImageName} src={imgSrc} alt={alt} priority={priority} width={width} height={height} style={{
    width: styleWidth,
    height: styleHeight
  }} object-fit={objectFit} sizes={sizes} placeholder={'empty'} onError={() => {
    setImgSrc(fallbackimage);
  }} unoptimized={true} data-sentry-element="Image" data-sentry-component="GridImages" data-sentry-source-file="GridImages.tsx" />;
};
export default GridImages;